module.exports = __webpack_public_path__ + "static/media/evnt-am-hd-bg.06158922.jpg";